import {kSupportProjectScreenTexts} from "../../../constants/texts";
import {kPotLink} from "../../../constants/links";
import {aboutScreenHighlightWords} from "../../../helpers/StringHelper";
import SupportProjectScreenGauges from "../../charts/supportProjectScreen/SupportProjectScreenGauges";

export default function SupportProjectContent() {
    // Used in AboutContent to display mission related content
    // in desktop / tablet mode

    // BUILD
    return(
        <div className={"animate-appearSlow w-full flex flex-col justify-start item-start"}>
            <div className={"w-full flex justify-start items-start space-x-[24px]"}>
                <div className={`h-[216px] min-h-[216px] w-[216px] min-w-[216px] flex justify-center items-center rounded-[16px] overflow-clip`}>
                    <img className={"object-contain w-full"}
                         src={'/images/supportProjectScreen/SupportFoxIllustration.png'}
                         alt="Courrier"/>
                </div>
                <div className={"text-[18px] text-greyLight9 font-medium"}>
                    <span className={""}>
                        {aboutScreenHighlightWords(kSupportProjectScreenTexts.introOne, ['soutenir le projet'])}
                    </span>
                    <a className={"text-primaryLight1 no-underline hover:underline"}
                       href={kPotLink}
                       rel="noopener noreferrer"
                       target="_blank">
                        {kSupportProjectScreenTexts.introTwo}
                    </a>
                    <span>
                        {aboutScreenHighlightWords(kSupportProjectScreenTexts.introThree, ['clair', 'calme', 'sans publicité', 'dédié à l\'enfant', 'apprendre', 'comprendre', 'progresser', 'revenir'])}
                    </span>
                </div>
            </div>
            <section className="mt-[16px] text-[18px] text-greyLight9 font-medium">
                <p>
                    {aboutScreenHighlightWords(kSupportProjectScreenTexts.bodyOne, ['soutien'])}
                </p>
                <ul className="mt-[4px] list-disc list-outside pl-[16px] text-[18px] font-medium">
                    <li>
                        {aboutScreenHighlightWords(kSupportProjectScreenTexts.bodyTwo, ['Couvrir', 'frais d\'hébergement'])}
                    </li>
                    <li>
                        {aboutScreenHighlightWords(kSupportProjectScreenTexts.bodyThree, ['Développer', 'vidéos pédagogiques', 'outils interactifs'])}
                    </li>
                    <li>
                        {aboutScreenHighlightWords(kSupportProjectScreenTexts.bodyFour, ['Finaliser', 'rédaction des savoir-faire', 'questions flash', 'exerciseurs', 'vidéos pédagogiques'])}
                    </li>
                </ul>
                <SupportProjectScreenGauges />
                <p className={"mt-[16px]"}>
                    {aboutScreenHighlightWords(kSupportProjectScreenTexts.conclusion, ['Chaque participation compte', 'indépendance', 'promesse'])}
                </p>
                <div className={"mt-[12px] flex justify-end items-center space-x-[12px]"}>
                    <p className={"text-end text-white"}>
                        {"L'équipe d'Ummia vous remercie"}
                    </p>
                    <img className={"object-contain w-[20px]"}
                         src={'/images/SystemFoxTrack.png'}
                         alt="Empreinte"/>
                </div>
            </section>
        </div>
    );
}